/** Puts text on the clipboard, throwing when the browser refuses. */
export async function copyText(value: string): Promise<void> {
  // navigator.clipboard is undefined outside a secure context (a plain-HTTP preview host).
  const clipboard = navigator.clipboard as Clipboard | undefined
  if (clipboard) {
    await clipboard.writeText(value)
    return
  }
  const field = document.createElement('textarea')
  field.value = value
  // Invisible and in-viewport, so selecting it neither flashes nor scrolls the page.
  field.style.cssText = 'position:fixed;top:0;left:0;opacity:0'
  document.body.appendChild(field)
  field.select()
  let copied = false
  try {
    copied = document.execCommand('copy')
  } finally {
    field.remove()
  }
  if (!copied) throw new Error('The browser refused the copy command')
}
